var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RegistrationWithoutLinkedGame',{attrs:{"game-id":_vm.gameId},on:{"isGameLinked":function($event){return _vm.$emit('isGameLinked')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }